/**
 * Mock Data: Tiering Settings
 * Static dataset for tiering settings UI layout.
 */

import type { TieringSettingsItem } from "../domain/model/TieringSettingsModel";

export type TieringSettingsResponse = {
  readonly data: readonly TieringSettingsItem[];
};

export const mockTieringSettingsData: TieringSettingsResponse = {
  data: [
    {
      id: "1",
      period: "2025",
      createdBy: "Ole Romeny",
      createdAt: "12 Nov 2024 10:10:23",
      updatedBy: "Ole Romeny",
      status: "ongoing",
      updatedAt: "12 Nov 2024 15:23:42",
    },
    {
      id: "2",
      period: "2024",
      createdBy: "Ole Romeny",
      createdAt: "12 Nov 2024 10:10:23",
      updatedBy: "Ole Romeny",
      status: "ended",
      updatedAt: "12 Nov 2024 15:23:42",
    },
    {
      id: "3",
      period: "2023",
      createdBy: "Ole Romeny",
      createdAt: "12 Nov 2024 10:10:23",
      updatedBy: "Ole Romeny",
      status: "ended",
      updatedAt: "12 Nov 2024 15:23:42",
    },
    {
      id: "4",
      period: "2022",
      createdBy: "Ole Romeny",
      createdAt: "12 Nov 2024 10:10:23",
      updatedBy: "Ole Romeny",
      status: "ended",
      updatedAt: "12 Nov 2024 15:23:42",
    },
    {
      id: "5",
      period: "2021",
      createdBy: "Ole Romeny",
      createdAt: "12 Nov 2024 10:10:23",
      updatedBy: "Ole Romeny",
      status: "ended",
      updatedAt: "12 Nov 2024 15:23:42",
    },
    {
      id: "6",
      period: "2020",
      createdBy: "Ole Romeny",
      createdAt: "12 Nov 2024 10:10:23",
      updatedBy: "Ole Romeny",
      status: "ended",
      updatedAt: "12 Nov 2024 15:23:42",
    },
  ],
};
